"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DataQualityStatusChip_1 = require("../../dataQualityWarnings/DataQualityStatusChip");
var DataQualityWarningFragments_1 = require("../../dataQualityWarnings/DataQualityWarningFragments");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var CellStyles_1 = require("./CellStyles");
var IconCellDiv = LayoutComponents_1.divWithStyle('IconCell', __assign(__assign({}, CellStyles_1.cellPaddingStyle), { height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 24 }));
var DisabledIconCellDiv = LayoutComponents_1.divWithStyle('DisabledIconCell', __assign(__assign({}, CellStyles_1.cellPaddingStyle), { height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 24, opacity: 0.6 }));
function DataQualityCell(props) {
    if (!props || !props.dataQualityWarning || !props.dataQualityWarning.isActive) {
        return null;
    }
    var detail = DataQualityWarningFragments_1.mapFragmentOrIndicatorToDetail(props.dataQualityWarning, true, props.urls);
    if (!detail) {
        return null;
    }
    return (props.disabled ? (React.createElement(DisabledIconCellDiv, null,
        React.createElement(DataQualityStatusChip_1.DataQualityStatusChip, { details: [detail], iconOnly: true, linksDisabled: props.linksDisabled || false, stackingRootId: props.stackingRootId }))) : (React.createElement(IconCellDiv, null,
        React.createElement(DataQualityStatusChip_1.DataQualityStatusChip, { details: [detail], iconOnly: true, linksDisabled: props.linksDisabled || false, stackingRootId: props.stackingRootId }))));
}
function createDataQualityCellFormatter(getWarningFromRowData, getDisabledFromRowData, linksDisabled, stackingRootId) {
    return function (props) {
        if (linksDisabled) {
            return (React.createElement(DataQualityCell, { dataQualityWarning: getWarningFromRowData(props.row.data), disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false, linksDisabled: linksDisabled, stackingRootId: stackingRootId }));
        }
        else {
            return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
                return React.createElement(DataQualityCell, { dataQualityWarning: getWarningFromRowData(props.row.data), disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false, linksDisabled: linksDisabled, stackingRootId: stackingRootId, urls: urls });
            }));
        }
    };
}
exports.createDataQualityCellFormatter = createDataQualityCellFormatter;
//# sourceMappingURL=QualityCellFormatter.js.map